import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/traxcn-companies/$id/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/company-intelligence/$id', params, replace: true })
  },
})
